'use client';

import { getClassNames } from '@/utils/helpers';
import { Paragraph, Label } from '@yaradigitallabs/ahua-react';

interface DescriptionProps {
  title: string;
  description: string;
  boldTitle?: boolean;
  boldDescription?: boolean;
  className?: string;
  isLoading?: boolean;
}

const Description: React.FC<DescriptionProps> = ({
  title,
  description,
  boldTitle = false,
  boldDescription = false,
  className = '',
  isLoading = false,
}) => {
  if (isLoading) {
    return <DescriptionSkeleton className={className} />;
  } else {
    return (
      <div className={getClassNames('description', className || '')}>
        <Label
          maxLineCount={1}
          size="s"
          className={getClassNames(
            'text-[#0f0f0f99]!',
            boldTitle ? 'font-bold' : ''
          )}
        >
          {title}
        </Label>
        {boldDescription ? (
          <Label
            maxLineCount={1}
            size="l"
            className={getClassNames(boldDescription ? 'font-bold' : '')}
          >
            {description}
          </Label>
        ) : (
          <Paragraph size="n">{description}</Paragraph>
        )}
      </div>
    );
  }
};

interface DescriptionSkeletonProps {
  className?: string;
}
export const DescriptionSkeleton: React.FC<DescriptionSkeletonProps> = ({
  className = '',
}) => {
  return (
    <div
      className={getClassNames(
        'p-4 min-w-[100px] lg:min-w-[150px] rounded animate-pulse',
        className || ''
      )}
    >
      <div className="h-6 bg-gray-300 rounded w-1/3 mb-2"></div>
      <div className="h-4 bg-gray-300 rounded w-full"></div>
    </div>
  );
};

export default Description;
